import { db } from "@/utils/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";

/**
 * Remove a user from a business
 * @param userId The ID of the user to remove
 * @param businessId The ID of the business to remove the user from
 * @returns A promise that resolves to true if the user was removed, false otherwise
 */
export const removeUserFromBusiness = async (
  userId: string,
  businessId: string
): Promise<boolean> => {
  try {
    console.log(`Removing user ${userId} from business ${businessId}`);
    
    // Get the business document
    const businessRef = doc(db, "businesses", businessId);
    const businessDoc = await getDoc(businessRef);
    
    if (!businessDoc.exists()) {
      console.error(`Business ${businessId} does not exist`);
      return false;
    }
    
    // Get the business data
    const businessData = businessDoc.data();
    
    // Check if the business has members
    if (!businessData.members || !Array.isArray(businessData.members)) {
      console.error(`Business ${businessId} has no members array`);
      return false;
    }
    
    // Define a type for the member object
    interface BusinessMember {
      userId: string;
      [key: string]: unknown;
    }
    
    // Find the member in the business
    const memberIndex = businessData.members.findIndex(
      (member: BusinessMember) => member.userId === userId
    );
    
    if (memberIndex === -1) {
      console.error(`User ${userId} is not a member of business ${businessId}`);
      return false;
    }
    
    // Remove the member from the array
    const updatedMembers = [
      ...businessData.members.slice(0, memberIndex),
      ...businessData.members.slice(memberIndex + 1)
    ];
    
    // Update the business document
    await updateDoc(businessRef, { members: updatedMembers });
    
    console.log(`Successfully removed user ${userId} from business ${businessId}`);
    return true;
  } catch (error) {
    console.error("Error removing user from business:", error);
    return false;
  }
};
